export default __webpack_public_path__ + "static/media/logo.c7a313b1.png";